import API from '@/api/Project'
import { path, mergeDeepRight } from 'ramda'
import MixinFactory from '@/store/mixin'
import { PartialUpdate } from '@/utils'
const Mixin = MixinFactory('Project')

let removeItemById = (target, id) => {
  if (!target) return
  let index = target.findIndex(t => t.id === id)
  if (!~index) return

  target.splice(index, 1)
}

let partialUpdateItemBy = (target, payload) => {
  if (!target) return

  let match = target.find(t => t.id === payload.id)
  if (!match) return

  PartialUpdate(match, payload, { strict: true })
}

const state = {
  ...Mixin.state,
}

const mutations = {
  ...Mixin.mutations,
  updateTask(state, payload) {
    partialUpdateItemBy(state.item.tasks, payload)
    partialUpdateItemBy(state.item.deadlines, payload)
    partialUpdateItemBy(state.item.lastActivity, payload)
  },
  removeTask(state, payload) {
    removeItemById(state.item.tasks, payload.id)
    removeItemById(state.item.deadlines, payload.id)
    removeItemById(state.item.lastActivity, payload.id)
  },
  addon(state, payload) {
    if (!state.item.id) return
    if (payload.state) state.item.metadata.addons.push(payload.addon)
    else state.item.metadata.addons.splice(state.item.metadata.addon.indexOf(payload.addon), 1)
  },
}

const actions = {
  fetch: Mixin.actions.fetch(API.get),
  mutate: Mixin.actions.mutate(API.mutate),
  remove: Mixin.actions.remove(API.delete),
  updateSchema({ commit, state }) {
    if (!state.item.id) return
    return API.get({ id: state.item.id }, { query: "ProjectSchemaUpdate" }).then(data => {
      commit('set', mergeDeepRight(state.item, data))
    })
  },
  addon({ commit, state }, payload) {
    if (!payload.project && !state.item.id) return
    return API.addon({ project: state.item.id, ...payload }).then(() => {
      commit('addon', payload)
    })
  },
}

const getters = {
  hasRole: state => (role, context) => {
    if (!context) context = state.item
    role = role instanceof Array ? role : [role]
    if (!path(['access', 'roles', 'length'], context)) return false
    return role.some(r => {
      if (r instanceof RegExp) return context.access.roles.some(ro => ro.match(r))
      return context.access.roles.includes(r)
    })
  },
  getDisabledField: state => field => {
    const disabledFields = path(['item', 'metadata', 'disabledFields'], state)

    if (!disabledFields) return

    if ('project' in disabledFields && !field.startsWith('project.')) return disabledFields.project[field]

    const type = ['project', 'unit', 'post'].find(t => field.startsWith(`${t}.`))
    if (type) return disabledFields[type][field.replace(new RegExp(`^${type}\.`), '')]

    return disabledFields[field]
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
